import React from 'react';

const TabNavItem = ({ id, title, icon, activeTab, setActiveTab }) => {
    const isActive = activeTab === id;

    return (
        <li className="nav-item" role="presentation">
            <button
                type="button"
                role="tab"
                className={`nav-link ${isActive ? 'active' : ''}`}
                onClick={() => setActiveTab(id)}
                aria-selected={isActive}
            >
                <i className={icon}></i>
                <small> {title}</small>
            </button>
        </li>
    );
};

export default TabNavItem;
